import { ReactNode, useEffect, useMemo } from 'react';
import createLogger from '../utils/telemetry';
import { ENV_VALIDATION_ERRORS } from '../config/env';
import { LoggerContext } from './useLogger';

interface LoggerProviderProps {
  namespace: string;
  children: ReactNode;
}

// Provider du contexte
export const LoggerProvider = ({ namespace, children }: LoggerProviderProps) => {
  const logger = createLogger(namespace);
  const value = useMemo(() => ({ logger }), [logger]);

  useEffect(() => {
    if (ENV_VALIDATION_ERRORS.length > 0) {
      logger.warn("Configuration d'environnement invalide :", {
        issues: ENV_VALIDATION_ERRORS,
      });
    }
  }, [logger]);

  return <LoggerContext.Provider value={value}>{children}</LoggerContext.Provider>;
};
